import WeeklyGenericBarChart from "../../../../../components/Reports/GenericCharts/BarCharts/WeeklyBarChart/WeeklyGenericBarChart";
import { PNL_CATEGORIES_TO_COLORS_MAP } from "../../../../../constants/constants";
import PciCustomLegend from "reports/pages/customers/pci/Utils/PciCustomLegend";
import { Bar, Cell, LabelList } from "recharts";
import { pnlCategoriesData } from "reports/types";

/**
 * generate and create bar chart based on given data
 */

const MAX_NUMBER_OF_DOWNTIME_BARS = 5;

// empty because using custom bars
const bars = [];
export default function DowntimePareto({
  data,
  date,
  width,
  height,
}: {
  data: pnlCategoriesData[] | null;
  date?: string;
  width: number;
  height: number;
}) {
  // sort with the largest entry first
  const dataSorted = data
    ? [...data].sort((entry1, entry2) => entry2.totalTime - entry1.totalTime)
    : [];

  // TODO: This can be passed in from a config object in the future - Daniel (written for future reference)
  const desiredCategories = ["waiting", "unknown", "unplanned"]; // the categories we want in this chart
  // filter out what we don't need
  const filteredData = dataSorted.filter(({ category }) => {
    return desiredCategories.includes(category);
  });
  // get MAX_NUMBER_OF_DOWNTIME_BARS
  const topXDowntimeData = filteredData?.slice(0, MAX_NUMBER_OF_DOWNTIME_BARS);

  const customBars = (
    <Bar dataKey="totalTime">
      {filteredData?.map(({ category }, index) => (
        <Cell
          key={`customBarCell-${index}`}
          fill={PNL_CATEGORIES_TO_COLORS_MAP[category]}
        />
      ))}
      <LabelList dataKey={"timeAndOccurences"} position="right" fill="black" />
    </Bar>
  );

  const title = `Downtime Pareto Week of: ${date}`;
  return (
    <WeeklyGenericBarChart
      data={topXDowntimeData}
      bars={bars}
      customBars={customBars}
      xKey={"totalTime"}
      xLabel={"Hours"}
      yLabel={"Counts"}
      yKey={"tag"}
      title={title}
      vertical={true}
      width={width}
      height={height}
      legend={PciCustomLegend(width, title)}
    />
  );
}
